// @ts-nocheck
import request from '../request';

//TODO: Will be deprecated soon, use bookings/complete instead
export const createBooking = (data = {}) =>
  request.post('bookings', data).then((res) => res);

export const completeBooking = (data = {}) =>
  request.post('bookings/complete', data).then((res) => res);

export const uploadCheckoutPassengerFieldFile = ({
  tripId,
  tripPassengerFieldId,
  clientPassengerKey,
  file
}) => {
  const data = new FormData();
  data.append('tripId', tripId);
  data.append('tripPassengerFieldId', tripPassengerFieldId);
  data.append('clientPassengerKey', clientPassengerKey);
  data.append('file', file, file?.name);

  return request
    .post('checkout/passenger-field-files', data)
    .then((res) => res);
};

export const getBookingById = (
  bookingId = '',
  bookingKey = '',
  transactionId
) =>
  request
    .get(
      `bookings/${bookingId}?bookingkey=${encodeURIComponent(bookingKey)}${transactionId == null ? '' : `&transactionid=${encodeURIComponent(transactionId)}`}`
    )
    .then((res) => res);

export const createPassenger = (data = {}) =>
  request.post('bookingpassengers', data).then((res) => res);

export const createPassengers = (bookingid = '', data = {}) =>
  request.post(`bookings/${bookingid}/passengers`, data).then((res) => res);

export const updateBookingPassenger = async (
  tripid = '',
  bookingid = '',
  bookingpassengerid = '',
  data = {}
) => {
  return request
    .put(
      `/trips/${tripid}/bookings/${bookingid}/bookingpassengers/${bookingpassengerid}/passengerfields`,
      data
    )
    .then((res) => res);
};

export const updateBookingPassengerFieldState = (
  tripid = '',
  bookingid = '',
  bookingpassengerid = '',
  trippassengerfieldid = '',
  state = null
) =>
  request.put(
    `/trips/${tripid}/bookings/${bookingid}/bookingpassengers/${bookingpassengerid}/passengerfields/${trippassengerfieldid}/state`,
    { state }
  );

export const resolvePassengerFieldProposals = (
  tripid = '',
  proposalIds = [],
  action = ''
) =>
  request.post(`/trips/${tripid}/passengerfield-proposals/resolve`, {
    proposalIds,
    action
  });

export const verifyPassengerFields = (
  tripid = '',
  cells = [],
  reviewState = 'VERIFIED'
) =>
  request.put(`/trips/${tripid}/passengerfields/review-state`, {
    cells,
    reviewState
  });

export const getPassengerFieldFiles = async (
  bookingpassengerid = '',
  trippassengerfieldid = ''
) => {
  return request
    .get(
      `/bookingpassengers/${bookingpassengerid}/passengerfields/${trippassengerfieldid}/files`
    )
    .then((res) => res);
};

export const uploadPassengerFieldFiles = async (
  bookingpassengerid = '',
  trippassengerfieldid = '',
  data = {}
) => {
  return request
    .post(
      `/bookingpassengers/${bookingpassengerid}/passengerfields/${trippassengerfieldid}/files`,
      data
    )
    .then((res) => res);
};

export const downloadPassengerFieldFile = async (
  bookingpassengerid = '',
  trippassengerfieldid = '',
  fileid = ''
) => {
  return request
    .get(
      `/bookingpassengers/${bookingpassengerid}/passengerfields/${trippassengerfieldid}/files/${fileid}/download`,
      { responseType: 'blob' }
    )
    .then((res) => res);
};

export const deletePassengerFieldFile = async (
  bookingpassengerid = '',
  trippassengerfieldid = '',
  fileid = ''
) => {
  return request
    .delete(
      `/bookingpassengers/${bookingpassengerid}/passengerfields/${trippassengerfieldid}/files/${fileid}`
    )
    .then((res) => res);
};

export const generatePassengersPdf = async (data = {}) => {
  const resp = await request
    .post('bookingpassengers/pdf', data)
    .then((res) => res);
  return resp;
};

export const getTripBookingPassenger = (tripid = '') => {
  return request.get(`/trips/${tripid}/bookingpassengers`).then((res) => res);
};

export const getPassengerFormFieldsRounds = (
  passengerkey = '',
  effectiveDate = null
) => {
  return request
    .get(
      `/bookingpassengers/${passengerkey}/passenger-form${effectiveDate ? `?effectiveDate=${effectiveDate}` : ''}`
    )
    .then((res) => res);
};

export const savePassengerFormFieldsRounds = (passengerkey = '', data = {}) => {
  return request
    .post(`/bookingpassengers/${passengerkey}/passenger-form`, data)
    .then((res) => res);
};

export const generatePassengerSignedDocumentByPassengerKey = (
  passengerkey = '',
  data = {}
) => {
  return request
    .post(
      `/bookingpassengers/by-key/${passengerkey}/generate-signed-document`,
      data
    )
    .then((res) => res);
};

export const generatePassengerSignedDocumentByPassengerId = (
  bookingpassengerid = '',
  passengerkey = '',
  data = {}
) => {
  const passengerKeyQuery = passengerkey
    ? `?passengerkey=${encodeURIComponent(passengerkey)}`
    : '';

  return request
    .post(
      `/bookingpassengers/${bookingpassengerid}/generate-signed-document${passengerKeyQuery}`,
      data
    )
    .then((res) => res);
};

export const generatePassengerSignedDocument = (
  bookingpassengerid = '',
  data = {},
  passengerkey = ''
) => {
  return generatePassengerSignedDocumentByPassengerId(
    bookingpassengerid,
    passengerkey,
    data
  );
};

// @ts-ignore
export const getTokenFromEsignatureProvider = async (trip, data) => {
  return request
    .post(`bookings/trip/${trip?.tripid}/generate-signed-document`, data)
    .then((res) => {
      const response = res?.data || {};

      return {
        token: response.token || response.recipients?.[0]?.token,
        documentId:
          response.externalDocumentId ||
          response.envelopeId ||
          response.documentId
      };
    });
};

export const getBookingPaymentInfo = async (bookingid = '') => {
  return request.get(`/bookings/${bookingid}/payment-info`).then((res) => res);
};

export const getTripBookings = async (tripId = '') => {
  return request.get(`/bookings/trip/${tripId}`).then((res) => res);
};

export const requestPaymentBulkRefund = async (data = {}) => {
  return request
    .post(`/payments/stripe/refund/bulk`, data)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

export const requestPaymentRefund = async (refundid = '', data = {}) => {
  return request
    .post(`/payments/stripe/refund/${refundid}`, data)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

export const getManageBookingById = (bookingId = '') =>
  request.get(`bookings/${bookingId}/manage`).then((res) => res);

export const deleteManageBookingPassengers = (bookingId = '', data = {}) =>
  request.delete(`bookings/${bookingId}/manage`, { data }).then((res) => res);

export const updateBookingPlan = (
  bookingId = '',
  bookingPlanId = '',
  data = {}
) =>
  request
    .put(`bookings/${bookingId}/bookingplan/${bookingPlanId}`, data)
    .then((res) => res);

export const adjustBookingPrice = (bookingId = '', data = {}) =>
  request.put(`bookings/${bookingId}/adjust-price`, data).then((res) => res);

export const createBookingPassengerAddOnsBulk = (bookingId = '', data = {}) =>
  request.post(`bookings/${bookingId}/addons/bulk`, data).then((res) => res);

export const updateBookingAddOns = (bookingId = '', data = {}) =>
  request.put(`bookings/${bookingId}/addons/bulk`, data).then((res) => res);

export const getSignedDocument = (bookingId = '') =>
  request.get(`bookings/${bookingId}/signed-document`).then((res) => res);

export const getPassengerSignedDocuments = (bookingId = '') =>
  request
    .get(`bookings/${bookingId}/passenger-signed-documents`)
    .then((res) => res);

export const getBookingEvents = (bookingId = '') =>
  request.get(`bookings/${bookingId}/events`).then((res) => res);
